import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryBirthEcc = () => {
  return <CategoryBase baseEndpoint="category_birth_ecc" />;
};

export default CategoryBirthEcc;
